export default __webpack_public_path__ + "static/media/traitIcons.a8aef1f7.png";